import type { AssignmentScope } from '@Application/Ai/AiConfiguration/Assignments/AssignmentScope';
import type { ModelAssignmentPayload } from '@Application/Ai/AiConfiguration/Assignments/Actions/modelAssignmentsFetched';

// Same shape as one entry of the `GET` response, for this single usage: the caller applies the
// result without a refetch.
export type UsageSettingsSavedPayload = ModelAssignmentPayload;

export type UsageSettingsSavedAction = {
	type: 'USAGE_SETTINGS_SAVED';
	payload: UsageSettingsSavedPayload;
	scope: AssignmentScope;
};

export default (payload: UsageSettingsSavedPayload, scope: AssignmentScope): UsageSettingsSavedAction => ({
	type: 'USAGE_SETTINGS_SAVED',
	payload,
	scope,
});
